import { render, staticRenderFns } from "./ModuleDesc.vue?vue&type=template&id=8979dbd2&scoped=true&"
import script from "./ModuleDesc.vue?vue&type=script&lang=js&"
export * from "./ModuleDesc.vue?vue&type=script&lang=js&"
import style0 from "./ModuleDesc.vue?vue&type=style&index=0&id=8979dbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8979dbd2",
  null
  
)

export default component.exports